import React, { useEffect, useContext } from 'react';
import { Form, Header, List, Radio } from 'semantic-ui-react';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import { formatVariationPrice } from './VariationSelection.utils';
import { ItemCartContext } from '../../CatalogItemCart.context';
import './VariationSelection.css';
function VariationSelection() {
  var _useContext = useContext(ItemCartContext),
    setFormError = _useContext.setFormError,
    loading = _useContext.loading,
    variations = _useContext.variations,
    selectedVariation = _useContext.selectedVariation,
    setSelectedVariation = _useContext.setSelectedVariation;
  var sortedVariations = _sortBy(variations, ['order']);
  var formErrorKey = 'variations';
  if (sortedVariations.length === 0) {
    return null;
  }
  var _sortedVariations$ = sortedVariations[0],
    defaultVariationPrice = _sortedVariations$.price,
    defaultVariationId = _sortedVariations$._id;
  useEffect(function () {
    if (!selectedVariation) {
      setSelectedVariation(defaultVariationId);
    } else {
      setFormError(formErrorKey, '');
    }
  }, [selectedVariation]);
  if (sortedVariations.length === 1) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "variation-selection"
  }, /*#__PURE__*/React.createElement(Header, {
    size: "small"
  }, "Choose a Type"), /*#__PURE__*/React.createElement(List, {
    className: "variation-selection-radio"
  }, _map(sortedVariations, function (_ref) {
    var _id = _ref._id,
      name = _ref.name,
      price = _ref.price;
    return /*#__PURE__*/React.createElement(List.Item, {
      key: _id
    }, /*#__PURE__*/React.createElement(Form.Field, {
      className: "variation-selection-radio-option"
    }, /*#__PURE__*/React.createElement(Radio, {
      label: name,
      name: "variation",
      value: _id,
      checked: _id === selectedVariation,
      disabled: loading,
      onChange: function onChange() {
        return setSelectedVariation(_id);
      }
    }), /*#__PURE__*/React.createElement("span", null, formatVariationPrice(defaultVariationPrice, price))));
  })));
}
export default VariationSelection;